import React from "react";

import "./style.less";

import FiltersContainer from "../../../../../../components/FiltersContainer";

const ConfigNav = ({pages}) => (
    <div className={"ConfigNav noWidth"}>
        {pages && <FiltersContainer pages={pages} type={"config"} horizontal={true}/>}
    </div>
);

export default ConfigNav;
